import { ref, toRefs, watch } from '@nuxtjs/composition-api';

import { UA } from '@/node_modules/nuxt-user-agent/lib/types';
import { UseRainbowContext } from '~/context/RainbowContext';

import fetchMarkersFromStore from '../functions/biura/data/fetchMarkersFromStore';
import getMapFunctions from '../functions/biura/getMapFunctions';
import buildServiceConfig from '../functions/biura/serviceConfig/buildServiceConfig';
import TClusterRef from '../types/clusterRef';
import IMapBiuraServiceConfig from '../types/IMapBiuraServiceConfig';
import TMapRef from '../types/mapRef';

const useMapServiceBiura = () => {
  const { $ua }: { $ua: UA } = UseRainbowContext();
  const mapRef = ref() as TMapRef;
  const cluster = ref() as unknown as TClusterRef;
  const serviceConfig: IMapBiuraServiceConfig = buildServiceConfig({
    mapRef,
    cluster,
    isMobile: !($ua.isFromPc() || $ua.isFromTablet()),
  });

  const mapFunctions = getMapFunctions(serviceConfig);

  fetchMarkersFromStore(serviceConfig);

  watch(mapRef, async () => {
    if (!mapRef || !mapRef.value) return;

    await mapFunctions.init(serviceConfig);
    if (cluster?.value?.$clusterObject) { cluster.value.$clusterObject.setGridSize(50); }
  });

  return {
    ...toRefs(serviceConfig.mapState),
    ...mapFunctions,
    config: ref(serviceConfig.config),
    clusterDom: ref(mapFunctions.buildCluster()),
    markersInnerState: toRefs(serviceConfig.markersInnerState),
    mapRef,
    cluster,
  };
};
export default useMapServiceBiura;
